var React = require('react');

function ChevronDownLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.417551 0.832917C0.591582 0.644532 0.829718 0.500474 1.06852 0.500474C1.2841 0.500474 1.49963 0.57837 1.67023 0.735948L12.5908 10.7701L23.5113 0.735948C23.8715 0.403505 24.4333 0.424272 24.7641 0.786164C25.0965 1.1463 25.074 1.70535 24.7147 2.0378L13.1902 12.6759C12.8492 12.9911 12.3281 12.9911 11.9868 12.6759L0.462341 2.0378C0.107609 1.75267 0.0851145 1.19306 0.417551 0.832917Z","fill":"#727176"}));
}

ChevronDownLight.defaultProps = {"width":"25","height":"13","viewBox":"0 0 25 13","fill":"none"};

module.exports = ChevronDownLight;

ChevronDownLight.default = ChevronDownLight;
